import { render, staticRenderFns } from "./sw-reset-password.vue?vue&type=template&id=43e856e4&scoped=true&"
import script from "./sw-reset-password.vue?vue&type=script&lang=ts&"
export * from "./sw-reset-password.vue?vue&type=script&lang=ts&"
import style0 from "./sw-reset-password.vue?vue&type=style&index=0&id=43e856e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e856e4",
  null
  
)

export default component.exports